module.exports = __webpack_public_path__ + "img/roule_img_01.621dd3de.jpg";